import React from 'react';

export default function Forgot() {
  return (
    <>
      Forgot Password Placeholder
    </>
  );
};